import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["title"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 规格图片 ", -1)
const _hoisted_6 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_7 = { style: {"width":"100% !important"} }
const _hoisted_8 = { style: {"width":"100%","height":"100%","text-align":"center","background-color":"#fff"} }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"90px"} }, null, -1)
const _hoisted_12 = { style: {"clear":"both"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_product_menu = _resolveComponent("product-menu")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_product_menu),
    (_openBlock(), _createBlock(_component_miezz_page_list, {
      modelValue: _ctx.list,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.list) = $event)),
      key: _ctx.pageRandom,
      onHandleGet: _ctx.handleGet,
      onHandleTopButtonClick: _ctx.handleTopButtonClick,
      onHandleRowButtonClick: _ctx.handleRowButtonClick,
      onHandleBottomButtonClick: _ctx.handleBottomButtonClick
    }, {
      column: _withCtx(({ model, row }) => [
        (model.Prop == 'PackageImages')
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
              (row.PackageImages!=null && row.PackageImages!=undefined && row.PackageImages.length>0)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    style: {"cursor":"pointer","color":"#fe995b","font-weight":"900"},
                    onClick: ($event: any) => (_ctx.onImage(row))
                  }, " 查看 ", 8, _hoisted_2))
                : (_openBlock(), _createElementBlock("span", _hoisted_3, "暂无数据"))
            ]))
          : _createCommentVNode("", true),
        (model.Prop == 'PackageZh')
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              title: row.PackageZh.Name,
              style: {"height":"30px","line-height":"28px","width":"100% !important","overflow":"hidden","word-break":"break-all"}
            }, _toDisplayString(row.PackageZh.Name), 9, _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      headerRight: _withCtx(() => [
        (_ctx.isManageOtherCompany==true && (_ctx.productId==undefined || _ctx.productId==''))
          ? (_openBlock(), _createBlock(_component_el_select, {
              size: "small",
              modelValue: _ctx.selectCompanyId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectCompanyId) = $event)),
              key: _ctx.companyRandom,
              style: {"margin-right":"10px"},
              placeholder: "请选择",
              onChange: _ctx.onChangeCompany
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companys, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.Id,
                    label: item.Name,
                    value: item.Id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onHandleGet", "onHandleTopButtonClick", "onHandleRowButtonClick", "onHandleBottomButtonClick"])),
    (_ctx.imageForm != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: _ctx.imageForm.Visiable,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.imageForm.Visiable) = $event)),
          "show-close": false,
          style: {"width":"50%"},
          top: "30px",
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_carousel, {
                interval: 5000,
                arrow: "always"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageForm.Rows, (p, index) => {
                    return (_openBlock(), _createBlock(_component_el_carousel_item, { key: index }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("a", {
                            href: p.Url,
                            target: "_blank"
                          }, [
                            _createElementVNode("img", {
                              style: {"height":"100%"},
                              src: p.Url
                            }, null, 8, _hoisted_10)
                          ], 8, _hoisted_9)
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.bottomButtonsImage,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bottomButtonsImage) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickImage
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}